module.exports = __webpack_public_path__ + "assets/favicon-48x48-dev.71cc2c953cf5e6a68880481a9530204d.png";